import { Controller } from "@hotwired/stimulus"

// The form of a staff message (the thread's composer, a message's edit form): the text box's placeholder follows the
// picked type, Ctrl or ⌘ + Enter posts it, and the text box takes the focus when the form shows — also after each post,
// since the thread is rendered again. The composer's reminder: a shortcut fills its date, and whom it goes to shows
// once a date is set.
export default class extends Controller {
  static targets = ["body", "followUpOn", "followUpPreset", "followUpAssignee"]
  static values = { placeholders: Object }

  connect () {
    this.updatePlaceholder()
    if (this.bodyTarget.offsetParent !== null) this.bodyTarget.focus()
  }

  updatePlaceholder () {
    const kind = this.element.querySelector("input[name='staff_message[kind]']:checked")?.value
    const placeholder = this.placeholdersValue[kind]
    if (placeholder) this.bodyTarget.placeholder = placeholder
  }

  submitOnShortcut (event) {
    if (event.key !== "Enter" || !(event.metaKey || event.ctrlKey)) return

    event.preventDefault()
    this.element.requestSubmit()
  }

  setFollowUp (event) {
    const date = event.currentTarget.dataset.date
    this.followUpOnTarget.value = this.followUpOnTarget.value === date ? "" : date
    this.followUpChanged()
  }

  clearFollowUp () {
    this.followUpOnTarget.value = ""
    this.followUpChanged()
  }

  followUpChanged () {
    const date = this.followUpOnTarget.value
    this.followUpPresetTargets.forEach((preset) => {
      preset.setAttribute("aria-pressed", String(preset.dataset.date === date))
    })
    if (this.hasFollowUpAssigneeTarget) this.followUpAssigneeTarget.hidden = date === ""
  }
}
